import React, { useRef } from "react";
import SignatureCanvas from "react-signature-canvas";

const InputSignature = ({ label, value, onChange, error }) => {
const sigRef = useRef({});

  const clearSignature = () => {
    sigRef.current.clear();
    onChange(null);
  };

  const saveSignature = () => {
    if (!sigRef.current.isEmpty()) {
      const dataURL = sigRef.current.getTrimmedCanvas().toDataURL("image/png");
      onChange(dataURL);
    }
  };

  return (
    <div className="w-full">
      <label className="text-sm font-semibold">{label} <span className='text-red-500'> *</span></label>

      <div className="border border-gray-400 rounded-md mt-1 bg-white">
        <SignatureCanvas
          ref={sigRef}
          onEnd={saveSignature}
          canvasProps={{
            width: 450,
            height: 160,
            className: "rounded-md"
          }}
        />
      </div>

      <button
        type="button"
        className="text-xs text-blue-600 mt-1"
        onClick={clearSignature}
      >
        Hapus Tanda Tangan
      </button>

      {error && <p className="text-red-500 text-xs italic">{error.message}</p>}
    </div>
  );
};

export default InputSignature;
